import MegaWinMusic from './MegaWinMusic';
export default MegaWinMusic;